export const NEWBORN_SKIN_RISK_ASSESSMENT = {
    masterTableName: "MC_NEO_SKIN_RISK_ASS_SCALE",
    tableName: "MC_NEO_SKIN_RISK_ASS_SCA_DET",
    columnName: "NSRAS_ID",
    columnValue: 0,
    title: "newborn-skin-risk-assessment.title",
    rows: [
        { title: "id", value: "ID" },
        { title: "process_time", value: "PROCESS_TIME", headerName: "newborn-skin-risk-assessment.process-time", type: "date" },
        { title: "CUSER", value: "CUSER" },
        { title: "RISK_ASSESSMENT_TEXT", value: "RISK_ASSESSMENT_ID_XNAME" },
        { title: "GPC_TEXT", value: "GENERAL_PHYSICAL_CONDIT_XNAME" },
        { title: "MENTAL_TEXT", value: "MENTAL_STATUS_XNAME" },
        { title: "MOBILITY_TEXT", value: "MOVEMENT_ABILITY_ID_XNAME" },
        { title: "ACTIVITY_TEXT", value: "PHYSICAL_ACTIVITY_ID_XNAME" },
        { title: "NUTRITION_TEXT", value: "NUTRITION_ID_XNAME" },
        { title: "MOISTURE_TEXT", value: "SKIN_MOISTURE_CONDITION_XNAME" },
        { title: "RESULT", value: "CALC_VALUE" },
    ],
    fields: [
        { field: "process_time", headerName: "newborn-skin-risk-assessment.process-time", flex: 1 },
        { field: "CUSER", headerName: "createdby", flex: 1 },
        { field: "RISK_ASSESSMENT_TEXT", headerName: "newborn-skin-risk-assessment.risk-assessment", flex: 1 },
        { field: "GPC_TEXT", headerName: "newborn-skin-risk-assessment.general-physical-condition", flex: 1 },
        { field: "MENTAL_TEXT", headerName: "newborn-skin-risk-assessment.mental-status", flex: 1 },
        { field: "MOBILITY_TEXT", headerName: "newborn-skin-risk-assessment.mobility", flex: 1 },
        { field: "ACTIVITY_TEXT", headerName: "newborn-skin-risk-assessment.activity", flex: 1 },
        { field: "NUTRITION_TEXT", headerName: "newborn-skin-risk-assessment.nutrition", flex: 1 },
        { field: "MOISTURE_TEXT", headerName: "newborn-skin-risk-assessment.moisture-status", flex: 1 },
        { field: "RESULT", headerName: "score", flex: 1 },
    ],
    mcpConfig: {
        RISK_ASSESSMENT_ID: { mcpId: 7, field: "RISK_ASSESSMENT_ID", scoreField: "RISK_ASSESSMENT_ID_XVALUE" },
        GENERAL_PHYSICAL_CONDITION: { mcpId: 100, field: "GENERAL_PHYSICAL_CONDITION", scoreField: "GENERAL_PHYSICAL_CONDIT_XVALUE" },
        MENTAL_STATUS: { mcpId: 101, field: "MENTAL_STATUS", scoreField: "MENTAL_STATUS_XVALUE" },
        MOVEMENT_ABILITY_ID: { mcpId: 102, field: "MOVEMENT_ABILITY_ID", scoreField: "MOVEMENT_ABILITY_ID_XVALUE" },
        PHYSICAL_ACTIVITY_ID: { mcpId: 103, field: "PHYSICAL_ACTIVITY_ID", scoreField: "PHYSICAL_ACTIVITY_ID_XVALUE" },
        NUTRITION_ID: { mcpId: 104, field: "NUTRITION_ID", scoreField: "NUTRITION_ID_XVALUE" },
        SKIN_MOISTURE_CONDITION_ID: { mcpId: 105, field: "SKIN_MOISTURE_CONDITION_ID", scoreField: "SKIN_MOISTURE_CONDITION_XVALUE" },
    } as Record<string, { mcpId: number; field: string; scoreField: string }>,
    formData: {
        NSRAS_ID: "",
        PROCESS_TIME: new Date(),
        CTIME: new Date(),
        CUSER: "",
        NURSE_ID: "",
        RISK_ASSESSMENT_ID: "",
        GENERAL_PHYSICAL_CONDITION: "",
        MENTAL_STATUS: "",
        MOVEMENT_ABILITY_ID: "",
        PHYSICAL_ACTIVITY_ID: "",
        NUTRITION_ID: "",
        SKIN_MOISTURE_CONDITION_ID: "",
        CALC_VALUE: 0,
    },
    chartScoreField: "CALC_VALUE",
    chartTimeField: "PROCESS_TIME",
};
